import ReactDOM from 'react-dom'
import React from 'react'

import App from './app'
import SpontaneousApplicationForm from './application/spontaneous'
import { API_ENDPOINT, TOKEN } from './consts'

async function fetchOffers() {
  const req = await fetch(`${API_ENDPOINT}/offers`, {
    method: 'GET',
    headers: { Accept: 'application/json', Authorization: `Bearer ${TOKEN}` },
  })
  if (!req.ok) {
    throw new Error('Server side error when fetching offers')
  }
  const data = await req.json()
  return data.offers
}

function offerIsSpontaneous(o) {
  // return o.tags.includes('spontaneous')
  return o.slug === 'for-spontaneous-applications'
}

function initDom(offers = []) {
  const spontaneousOffer = offers.filter(offerIsSpontaneous)[0]
  const otherOffers = offers.filter(o => o !== spontaneousOffer)

  const career = document.getElementById('career')
  if (career) {
    ReactDOM.render(<App defaultOffers={otherOffers} />, career)
  }

  const spontaneous = document.getElementById('spontaneous')
  if (spontaneous && spontaneousOffer) {
    ReactDOM.render(
      <SpontaneousApplicationForm offer={spontaneousOffer} />,
      spontaneous
    )
  }
}

try {
  fetchOffers().then(
    offers => initDom(offers),
    () => initDom()
  )
} catch (e) {
  /* eslint-disable */
  console.log({ e })
  initDom()
}
